<template>
  <section
    v-if="variant === variants.v1 || variant === variants.v2"
    class="n-section-primary tw-min-h-[60vh] tw-space-y-5 tw-bg-cover tw-bg-center"
    :style="`background-image: url(${isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage});`"
  >
    <!-- variant 1 start-->
    <div v-if="variant === variants.v1">
      <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>
      <div class="tw-relative tw-z-10 tw-text-center">
        <h1>{{ vars.titleText }}</h1>
      </div>
    </div>
    <!-- variant 1 end-->

    <!-- variant 2 start-->
    <div v-else-if="variant === variants.v2">
      <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>
      <div class="tw-relative tw-z-10 tw-text-center">
        <h2 style="color: var(--c-text-secondary)">{{ vars.titleText }}</h2>
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
          <div
            v-for="(description, index) in descriptions"
            :key="`introsection-description-${index}`"
            class="tw-max-w-3xl"
            style="color: var(--c-text-secondary)"
          >
            {{ description.description }}
          </div>
        </div>
        <div class="tw-mt-10 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`introsection-button-${index}`"
            :external="true"
            :to="button.button_link"
            :class="`n-${button.button_type}`"
            >{{ button.button_label }}
          </nuxt-link>
        </div>
      </div>
    </div>
    <!-- variant 2 end-->
  </section>

  <section
    v-else-if="variant === variants.v3"
    class="n-section-secondary tw-min-h-[80vh] tw-space-y-5 tw-bg-cover tw-bg-center"
    :style="`background-image: url(${isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage});`"
  >
    <div class="tw-mt-auto tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center xl:tw-items-start">
      <div
        class="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-[0] tw-bg-black"
        :style="`opacity: ${vars.opacityAmountNumber ? vars.opacityAmountNumber : 30}%`"
      ></div>
      <MotionGroup
        is="div"
        preset="slideVisibleLeft"
        :duration="700"
        class="tw-z-10 tw-flex tw-w-full tw-flex-col tw-py-4 lg:tw-items-start"
        :style="`color: var(--c-${vars.textColor})`"
      >
        <h1 class="tw-text-center md:tw-text-left">
          {{ vars.titleText }}
        </h1>

        <p
          v-if="vars.descri̇pti̇onText"
          class="tw-mt-4 tw-max-w-[700px] tw-text-center md:tw-text-left 2xl:tw-max-w-[800px]"
        >
          {{ vars.descri̇pti̇onText }}
        </p>

        <div class="tw-mt-4 tw-flex tw-flex-wrap tw-justify-center tw-gap-8 md:tw-justify-start" v-if="buttons">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`introsection-button-${index}`"
            :to="button.link"
            :class="`n-${button.type}`"
          >
            {{ button.label }}
          </nuxt-link>
        </div>
      </MotionGroup>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },
  computed: {
    variant() {
      return useVariant(this.component);
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },

    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>

<style scoped>
h1 {
  color: var(--c-text_white);
}
</style>
